export enum EConnectStatuses {
    DEFAULT = 'DEFAULT',
    CONNECT = 'CONNECT',
    NOT_CONNECT = 'NOT_CONNECT',
    NOT_GIGABIT = 'NOT_GIGABIT',
}

type TVar = Record<EConnectStatuses, string>

export const titles: TVar = {
    DEFAULT: 'Проверить возможность подключения',
    CONNECT: 'В вашем доме можно подключить любой тариф',
    NOT_CONNECT: 'Проверить возможность подключения',
    NOT_GIGABIT: 'Тарифы, доступные в вашем доме',
};

export const additionalBtnText: TVar = {
    DEFAULT: '',
    CONNECT: 'Все тарифы',
    NOT_CONNECT: 'Оставить заявку',
    NOT_GIGABIT: 'Все тарифы 100 Мбит/с',
};

export const texts: TVar = {
    DEFAULT: '',
    CONNECT: 'Вот наши самые популярные и выгодные тарифы: выберите любой и настройте под себя.',
    NOT_CONNECT: 'Оставьте заявку на звонок, и мы вам позвоним. Посоветуем выгодные тарифы и расскажем, как их подключить.',
    NOT_GIGABIT: '',
};

export const alertText: TVar = {
    DEFAULT: '',
    CONNECT: 'Услуги можно подключить',
    NOT_CONNECT: 'Пока ваш дом не подключен к Дом.ру.',
    NOT_GIGABIT: 'Пока в вашем доме можно подключить только тариф с максимальной скоростью <b>100 Мбит/с.</b>',
};
